import type { GetStaticProps } from 'next'
import type { Project } from '@/types'

import { Seo } from '@/components/generals/seo'
import { PageHero } from '@/components/layout/page-hero'
import { ProjectGrid } from '@/components/projects/project-grid'
import { getProjects } from '@/lib/content'

interface ProjectsPageProps {
    projects: Project[]
}

export default function ProjectsPage({ projects }: ProjectsPageProps) {
    return (
        <>
            <Seo
                title='Selected Work'
                description='A selection of brand identities, product design, and motion work.'
            />
            <PageHero
                titleTop='Selected'
                titleBottom='Work'
                detail='I am a product designer living in London, focused on creating long lasting experiences.'
            />
            <div className='section'>
                <div className='container no-max-width'>
                    <ProjectGrid projects={projects} overlayWhite />
                </div>
            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps<ProjectsPageProps> = async () => {
    const projects = await getProjects()
    return { props: { projects }, revalidate: 60 }
}
